// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: "https://xar804cw9l.execute-api.us-east-1.amazonaws.com/dev/v2/",
  // apiUrl: "http://localhost:5000/v1/",
  b2cUrl: 'https://t8jgpjuvp1.execute-api.us-east-1.amazonaws.com/prod/v1/',
  applicationType: 'admin',
  agoraAppId: 'b8d6d3eb2f1444f2b0bec339e82ff50c',
  googleClientId: '31128397605-ehfr9gig028ojbfelc7gbq7u2e99bteg.apps.googleusercontent.com',
  facebookAppId: '1729180150888493'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
